import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { getOptionStats } from '../actions/index';

import QuestionOption from './QuestionOption';
import QuestionImage from './QuestionImage';

import '../styles/Question.css';

// const boldLast = body => {
//   const starr = body.split('.');
//   starr[starr.length - 1] = '<strong>'.concat(starr[starr.length - 1], '</strong>');
//   return starr.join('.');
// };

class Question extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {
    this.props.getOptionStats(this.props.currentQuestionId);
  }

  componentWillReceiveProps(next) {
    if (this.props.currentIndex !== next.currentIndex) {
      window.scrollTo(0, 0);
      this.props.getOptionStats(this.props.questions[next.currentIndex].id);
    }
  }

  render() {
    const { body, options } = this.props;

    return (
      <div className="question-wrapper">
        <div
          className="question-body"
          dangerouslySetInnerHTML={{ __html: unescape(body) }}
        />
        <div className="hide-not-mobile">
          <QuestionImage />
        </div>
        {options.map((o, index) => (
          <QuestionOption key={o.body} index={index} />
        ))}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const question = state.quiz.questions[state.quiz.currentQuestionIndex];

  return {
    body: question.body,
    options: question.options,
    currentIndex: state.quiz.currentQuestionIndex,
    currentQuestionId: question.id,
    questions: state.quiz.questions
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ getOptionStats }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Question);

// Question.propTypes = {
//   question: React.PropTypes.shape({
//     id: React.PropTypes.string.isRequired,
//     body: React.PropTypes.string.isRequired,
//     tags: React.PropTypes.arrayOf(React.PropTypes.shape({
//       title: React.PropTypes.string.isRequired,
//     }).isRequired),
//     options: React.PropTypes.arrayOf(React.PropTypes.shape({
//       id: React.PropTypes.string.isRequired,
//     }).isRequired),
//   }).isRequired,
//   mode: React.PropTypes.string.isRequired,
//   answered: React.PropTypes.bool.isRequired,
//   onOptionSelected: React.PropTypes.func.isRequired,
// };



// WEBPACK FOOTER //
// ./src/containers/Question.js